import React, { useContext, useEffect } from 'react';
import { Col, Row } from 'antd';
import RestSelect from 'components/RestInput/RestSelect';
import i18next from 'i18next';
import RestRangePickerInput from 'components/RestInput/RestRangePickerInput';
import { RestInputContext } from 'components/RestInput/RestInputContext';
import { useLocation, useParams } from 'react-router';
import { getFilterFromUrl } from 'utils/tools';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {
  getJobApplicationStatus,
  getJobRoles,
  getJobTypes,
  getQualifications,
  getStates,
} from 'redux/config/selectors';
import { DISPLAY_TYPES, PREFIX_URL } from 'configs/localData/constant';
import ReferenceInput from 'containers/rest/ReferenceInput';
import InfiniteSelect from 'components/InfiniteFormItem/InfiniteSelect';
import {
  useGetBasicInfoApplicationQuery,
  useGetCampaignsApplicationQuery,
  useGetJobReferenceApplicationQuery,
  useGetJobTemplateApplicationQuery,
  useGetWorkplaceApplicationQuery,
} from 'redux/@rtkQuery/jobApplication';

function FilterForm() {
  const { form } = useContext(RestInputContext);
  const { search } = useLocation();
  const { model } = useParams();

  const jobApplicationStatus = useSelector(getJobApplicationStatus);
  const jobApplicationsRole = useSelector(getJobRoles);
  const jobApplicationsState = useSelector(getStates);
  const jobApplicationsQualifications = useSelector(getQualifications);
  const JobApplicationType = useSelector(getJobTypes);

  useEffect(() => {
    const { filter } = getFilterFromUrl(search);

    const { lastUpdated, ...restFilter } = filter?.filter || {};

    form.setFieldsValue({
      lastUpdated: Object.values(lastUpdated || {}).map((item) => moment(item)),
      ...restFilter,
    });
  }, [form, search]);

  return (
    <Row gutter={16}>
      <Col lg={4} md={12} xs={12}>
        <InfiniteSelect
          name="applicantName"
          useQuery={useGetBasicInfoApplicationQuery}
          searchKey="fullName"
          showSearch
          placeholder="jobApplications.applicant"
          labelProp="fullname"
          valueProp="fullname"
        />
      </Col>
      {model === DISPLAY_TYPES.list && (
        <Col lg={4} md={12} xs={12}>
          <RestSelect
            source="status"
            placeholder="jobApplications.status"
            isShowTooltip
            resourceData={jobApplicationStatus}
            valueProp="application_id"
            titleProp="application_name"
            formatText={(data) => i18next.t(data)}
          />
        </Col>
      )}

      <Col lg={4} md={12} xs={12}>
        <InfiniteSelect
          name="jobReference"
          useQuery={useGetJobReferenceApplicationQuery}
          searchKey="jobReference"
          showSearch
          placeholder="jobApplications.jobReference"
          labelProp="jobReference"
          valueProp="jobReference"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <InfiniteSelect
          name="campaign"
          useQuery={useGetCampaignsApplicationQuery}
          searchKey="name"
          showSearch
          placeholder="jobListings.campaign"
          valueProp="name"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <RestSelect
          source="jobRole"
          placeholder="jobApplications.jobRole"
          isShowTooltip
          resourceData={jobApplicationsRole}
          valueProp="id"
          titleProp="name"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <InfiniteSelect
          name="jobTemplate"
          useQuery={useGetJobTemplateApplicationQuery}
          searchKey="templateName"
          showSearch
          placeholder="jobApplications.jobTemplate"
          labelProp="templateName"
          valueProp="templateName"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <RestSelect
          source="jobType"
          placeholder="jobApplications.jobType"
          isShowTooltip
          resourceData={JobApplicationType}
          valueProp="id"
          titleProp="name"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <InfiniteSelect
          name="workplace"
          useQuery={useGetWorkplaceApplicationQuery}
          searchKey="workplaceName"
          showSearch
          placeholder="jobApplications.workplace"
          labelProp="workplaceName"
          valueProp="workplaceName"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <ReferenceInput
          prefixUrl={PREFIX_URL.admin}
          source="brand"
          resource="brands"
          searchKey="brand.name"
          requestParams={{ centreIds: 'all' }}
          customApiResource="job-brands"
        >
          <RestSelect
            titleProp="name"
            valueProp="id"
            placeholder="centres.brandTitle"
            isFilterOption={false}
          />
        </ReferenceInput>
      </Col>
      <Col lg={4} md={12} xs={12}>
        <RestSelect
          source="state"
          placeholder="jobApplications.state"
          isShowTooltip
          resourceData={jobApplicationsState}
          autoComplete="off"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <RestSelect
          source="qualificationLevel"
          placeholder="jobApplications.qualificationLevel"
          isShowTooltip
          resourceData={jobApplicationsQualifications}
          valueProp="id"
          titleProp="name"
        />
      </Col>
      <Col lg={4} md={12} xs={12}>
        <RestRangePickerInput
          sourceGt="lastUpdated.from"
          sourceLt="lastUpdated.to"
          source="lastUpdated"
          placeholder="jobListings.lastUpdated"
          isShowTooltip
        />
      </Col>
    </Row>
  );
}

export default FilterForm;
